<template>
  <div>
    <a-skeleton active :loading="loading">
      <ListNotification
        :isClickAllViewed="isClickAllViewed"
        :notifications="notifications"
        :deleteNotifications="deleteNotifications"
        style="padding: 5px;"
      />
    </a-skeleton>
    <br />
    <a-button
      v-if="isFetchMore"
      :loading="$apollo.queries.notifications.loading"
      @click="fetchMore({ isViewed: false })"
      type="link"
      icon="sync"
      class="border-0"
    >
      Load more
    </a-button>
  </div>
</template>
<script>
import Query from "../query";
import ListNotification from "../ListNotification";
const startPage = 1;
const limit = 20;
export default {
  components: { ListNotification },
  props: {
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
    isClickAllViewed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      notifications: [],
      currentPage: startPage,
      isFetchMore: false,
      loading: false,
    };
  },
  mounted() {
    this.onGetNotifications();
  },
  methods: {
    onGetNotifications() {
      try {
        this.loading = true;
        this.$apollo.addSmartQuery("notifications", {
          query: Query.notifications,
          variables: { limit, page: this.currentPage, ...this.variablesQuery },
          fetchPolicy: "no-cache",
          result: (previousResult) => {
            this.loading = false;
            if (previousResult?.data?.notifications?.length < limit) {
              this.isFetchMore = false;
            } else {
              this.isFetchMore = true;
            }
          },
        });
      } catch (err) {
        this.loading = false;
        console.error("Cannot get notifications", err);
      }
    },

    fetchMore() {
      this.currentPage += 1;
      this.$apollo.queries.notifications.fetchMore({
        document: Query.notifications,
        variables: { limit, page: this.currentPage, ...this.variablesQuery },
        fetchPolicy: "no-cache",
        updateQuery: (previousResult, { fetchMoreResult }) => {
          // Here, return the new result from the previous with the new data

          this.notifications = [
            ...this.notifications,
            ...fetchMoreResult.notifications,
          ];
          if (fetchMoreResult.notifications?.length < limit) {
            this.isFetchMore = false;
          } else {
            this.isFetchMore = true;
          }
        },
      });
    },
    deleteNotifications(items, callback) {
      const { notifications } = this;
      for (const item of items) {
        const itemIndex = notifications.findIndex((e) => e.id === item.id);
        if (+itemIndex >= 0) {
          notifications.splice(itemIndex, 1);
        }
      }
      this.notifications = [...notifications];
      if (callback && typeof callback === "function") {
        callback();
      }
    },
  },
};
</script>
